// extracted by mini-css-extract-plugin
export var adjacentSlide = "_tb-9";
export var arrowButtonContainer = "_tb-5";
export var arrowButtonIcon = "_tb-6";
export var carouselArrowButton = "_tb-2";
export var carouselElementContainer = "_tb-1";
export var currentSlide = "_tb-8";
export var left = "_tb-3";
export var otherSlide = "_tb-a";
export var productCarouselContainer = "_tb-0";
export var right = "_tb-4";
export var sliderOverflow = "_tb-7";